import { Link, Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { deFiServicesData } from './DeFiServices.data';
import type { DeFiServicesProps } from './DeFiServices.types';
import {
  StyledStack,
  StyledButton,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';

export const DeFiServices = ({
  offerRef,
  ...props
}: DeFiServicesProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="orange" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={deFiServicesData.mainText}
        description={deFiServicesData.description}
        data={deFiServicesData.services}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
